document.addEventListener('DOMContentLoaded', function () {
    const formBlock = document.querySelector('.form-block');

    if (formBlock) {
        const hiddenInput = formBlock.querySelector('input[value="event_title"]');

        if (hiddenInput) {
            hiddenInput.value = document.title;
        }
    }
});
